import { debounce } from 'lodash'
/**
 * 监听屏幕滚动，添加回调函数
 */
export default {
  data() {
    return {
      scrollTop: 0,
      eventCallback: []
    }
  },
  mounted() {
    this.__scrollHandler = debounce(this.scrollWindow, 20)
    this.scrollWindow()
    window.addEventListener('scroll', this.__scrollHandler)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.__scrollHandler)
  },
  methods: {
    scrollWindow() {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      if (this.eventCallback.length) {
        this.eventCallback.forEach(c => {
          if (typeof c === 'function') {
            c()
          }
        })
      }
    }
  }
}
